import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTailwindcssComponent } from './simple-icons-tailwindcss.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTailwindcssComponent ],
    exports:      [ SimpleIconsTailwindcssComponent ],
    bootstrap:    []
})
export class SimpleIconsTailwindcssModule {}
